import { useEffect, useState } from 'react';
import axiosInstance from '../axios/axiosInstance';

function useGetCategoria() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const getCategorias = async () => {
    try {
      const res = await axiosInstance.get(`categoriaCompra/`);
      setResult(res.data);
      setLoading(false);
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        setLoading(false);
        return setResult({ error: 'ERR_NETWORK' });
      }
      setLoading(false);
      return setResult({ error: error.response.data });
    }
  };

  useEffect(() => {
    getCategorias();
  }, []);
  return { result, loading, getCategorias };
}

export default useGetCategoria;

export function useGetCategoriaProduto(id) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const getCategorias = async () => {
    try {
      const res = await axiosInstance.get(`categoria/?q=${id}`);
      setResult(res.data);
      setLoading(false);
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        setLoading(false);
        return setResult({ error: 'ERR_NETWORK' });
      }
      setLoading(false);
      return setResult({ error: error.response.data });
    }
  };
  useEffect(() => {
    getCategorias();
  }, []);
  return { result, loading, getCategorias };
}
